import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { AppLogoWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { LocalApp } from '../../interfaces/local-app'
import { PageService } from '../../services/page.service'
import { DynamicImageComponent } from '../dynamic-image/dynamic-image.component'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-app-logo',
  standalone: true,
  imports: [DynamicImageComponent],
  templateUrl: './app-logo.component.html',
  styleUrls: [],
})
export class AppLogoComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: AppLogoWidget

  url = ''

  constructor(private pageService: PageService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_APP)?.subscribe((app: LocalApp) => {
        if (app) {
          this.url = app.iconUrl
        } else {
          this.url = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
